import {tokens} from '@pleo-io/telescope'
import {graphql, PageProps} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import Footer from '@/components/footer'
import Header from '@/components/header'
import SEO from '@/components/seo'
import {LegalPageQuery} from '@/graphql-types'
import handleNoPrismicData from '@/utils/handle-no-prismic-data'
import {withPrismicPreview} from '@/utils/with-prismic-preview'
import RichText, {hasRichText} from '@helios/shared/components/rich-text'
import {Main} from '@helios/shared/components/skip-to-content'
import {Section} from '@helios/shared/styles/grid'
import mq from '@helios/shared/utils/media-query'

import LegalDocumentsGrid from './documents-grid'

type Props = PageProps<LegalPageQuery>

const LegalPage: React.FC<Props> = (props) => {
    const content = props.data.allPrismicLegalPage.nodes[0].data
    const legalDocsContent = props.data.allPrismicLegalDocuments.nodes[0]

    if (!content) {
        return handleNoPrismicData()
    }

    return (
        <>
            <SEO
                title={content.meta_title}
                description={content.meta_description}
                openGraphImageUrl={content.open_graph_image?.url}
            />

            <Header />

            <Main>
                {hasRichText(content.title) && (
                    <TitleSection>
                        <RichText content={content.title} size="xl" />
                    </TitleSection>
                )}

                <LegalDocumentsGrid content={legalDocsContent} />
            </Main>

            <Footer />
        </>
    )
}

export const TitleSection = styled(Section)`
    ${mq.min('sm')} {
        max-width: 780px;
        padding: 80px ${tokens.spacing60};
        text-align: center;
    }
`

export const SpacedSection = styled(Section)`
    display: grid;
    row-gap: ${tokens.spacing40};
`

export const query = graphql`
    query LegalPage($locale: String!) {
        allPrismicLegalPage(filter: {lang: {eq: $locale}}) {
            nodes {
                _previewable
                data {
                    meta_title
                    meta_description
                    open_graph_image {
                        alt
                        copyright
                        url
                        dimensions {
                            height
                            width
                        }
                    }
                    title
                }
            }
        }
        allPrismicLegalDocuments(filter: {lang: {eq: $locale}}) {
            nodes {
                _previewable
                ...LegalDocumentsGrid
            }
        }
    }
`

export default withPrismicPreview(LegalPage)
